import { DocumentListService } from './../../services/master-data.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MasterDataService } from '../../services/master-data.service';
import { CommonMessageService } from '../../services/common-message.service';

@Component({
  selector: 'app-document-folder-menu',
  templateUrl: './document-folder-menu.component.html',
  styleUrls: ['./document-folder-menu.component.css']
})
export class DocumentFolderMenuComponent implements OnInit {

  @Input() mainfolder;
  @Input() mainFolderSubFolders;
  // @Output() modalChanged =new EventEmitter();

  showSubfolder:boolean;
  constructor(private masterDataService:MasterDataService,
    private documentListService:DocumentListService,
    private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    console.log('document menu folder call');
    // var userRole=localStorage.getItem('userRole');
    // console.log('userRole',userRole);
    this.mainFolderSubFolders=[];
  }


  loadSubFolders(){
    this.showSubfolder=!this.showSubfolder;
    console.log('mainFolderSubFolders',this.mainFolderSubFolders);
    this.mainFolderSubFolders=this.mainfolder.subFolder;
    console.log('subfolderclick',this.mainFolderSubFolders);
  }

  // mainFolderDetail;
  // showOpenModal=false;
  // hideSaveButton=false;
  // onEditClick(mainfolder){
  //   this.mainFolderDetail=mainfolder;
  //   this.showOpenModal=true;
  //   this.modalChanged.emit({showOpenModal:false});
  //   this.hideSaveButton=true;
  // }

  // onDeleteClick(mainfolder){
  //   var confirmDelete = confirm("Are you sure you want to Delete?");
  //   if (confirmDelete == true) {
  //   this.masterDataService.deleteFolder(mainfolder.id).subscribe((resp:any)=>{
  //     this.commonMessageService.deleteMessage();
  //     this.modalChanged.emit({showOpenModal:false});
  //   });
  // }
  // }

  folderDetails(mainfolder){
    console.log('folder details',mainfolder);
    this.documentListService.sendDocument(mainfolder);
  }
}
